import { styled } from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;

  .calendar-card {
    cursor: pointer;
    width: 100%;
  }

  .creation-button {
    opacity: 1;
  }
`;
